import { PaginaNode } from '@gql/graphql'
import { MenuItemType } from '@utils/types'
import { CardGrid, GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './SostenibilitaHubTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
}

const SostenibilitaHubTemplate = (props: Props) => {
  const { pagina = undefined } = props

  const item: MenuItemType = {
    pk: pagina.pk,
    children:
      pagina?.menuChildren?.map((x) => ({ name: x.nome, image: x.previewImage, url: x.url })) || [],
    spaceTop: 'md',
  }

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <CardGrid item={item} />
        <Prefooter />
      </main>
    </Page>
  )
}

export default SostenibilitaHubTemplate
